import { render, staticRenderFns } from "./search-dropdown.vue?vue&type=template&id=03dd794c&scoped=true&lang=pug&"
import script from "./search-dropdown.vue?vue&type=script&lang=coffee&"
export * from "./search-dropdown.vue?vue&type=script&lang=coffee&"
import style0 from "./search-dropdown.vue?vue&type=style&index=0&id=03dd794c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dd794c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormTextfield: require('/opt/build/repo/library/components/globals/form/textfield.vue').default,Btn: require('/opt/build/repo/nuxt-app/components/globals/btn/btn.vue').default})
